import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { Vendor } from 'entities/vendor'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { VendorViewModel } from 'view_models/vendor_view_model'

export const vendorColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 40, form: form, orderAttr: 'vendor_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: '業者コード', th: true, width: 90, align: 'center', form: form, orderAttr: 'vendor_code', searchType: { name: 'code', type: 'text' } },
            { name: '業者名', th: true, width: 250, form: form, orderAttr: 'vendor_name', searchType: { name: 'nameIn', type: 'text' } },
            {
                name: '契約日',
                th: true,
                width: 90,
                form: form,
                orderAttr: 'vendor_contract_date',
                searchType: { name: 'contract_date', type: 'date' },
            },
            {
                name: '電話番号',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'vendor_tel',
                searchType: { name: 'tel', type: 'text' },
            },
            {
                name: '住所',
                th: true,
                minWidth: 300,
                form: form,
                orderAttr: 'vendor_address_id',
                searchType: { name: 'address', type: 'text' },
            },
        ],
    }
}

export type VendorTableDataProps = {
    vendor?: Vendor
    displaySetting: DisplaySetting
}

export const VendorTableData = ({ vendor, displaySetting }: VendorTableDataProps): JSX.Element => {
    if (!vendor) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }
    const vm = new VendorViewModel(vendor)

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{vendor.id}</TableCell>
                <TableCell align="center">{vendor.code}</TableCell>
                <TableCell>{vendor.name}</TableCell>
                <TableCell>{vm.contractDateText()}</TableCell>
                <TableCell>{vendor.tel}</TableCell>
                <TableCell>{vm.addressVm().wholeView()}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
